// extracted by mini-css-extract-plugin
module.exports = {"container":"PositionBriefCardLoader_container__3YMN8"};